import styled from 'styled-components';
export const Grid = styled.div`
  width: 100%;
  display: grid;
  align-items: start;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
`;
